import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { clientsAPI } from '../../lib/clientsAPI';
import { EmailComposer } from './EmailComposer';

// Timeline → "Email": new email to the client from a connected mailbox.
export const NewEmailDialog = ({ open, clientId, mailboxes, onClose, onSent }) => {
  const [to, setTo] = useState(null);
  useEffect(() => {
    if (!open) return;
    clientsAPI.listPeople(clientId).then((r) => {
      const people = r.data || [];
      setTo((people.find((p) => p.is_primary && p.email) || people.find((p) => p.email) || {}).email || '');
    }).catch(() => setTo(''));
  }, [open, clientId]);
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl" data-testid="timeline-email-dialog">
        <DialogHeader><DialogTitle>New email</DialogTitle><DialogDescription>Sent through your firm's mailbox so it lands in Sent Items and replies thread back here.</DialogDescription></DialogHeader>
        {to !== null && <EmailComposer mailboxes={mailboxes} clientId={clientId} defaults={{ to, subject: '' }} onSent={onSent} />}
      </DialogContent>
    </Dialog>
  );
};
